import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/query';

export const TENANT_CHANGED_EVENT = 'sentientos:tenant-changed';
export const TENANT_STORAGE_KEY = 'sentientos:tenant-context';
let context = '';
let identity = '';
let controller = new AbortController();

export function getTenantContext() {
  return context;
}

export function getTenantSignal() {
  return controller.signal;
}

export function adoptTenantContext(user) {
  const next = user ? `${user.active_organization || 'none'}:${user.is_impersonating ? 'guest' : 'member'}` : '';
  // Identity changes also invalidate requests even when the org stays the same.
  controller.abort();
  controller = new AbortController();
  context = next;
  identity = user?.uuid || '';
}

export function serializeTenantQueryArgs(args) {
  if (args.endpointName === 'getSession') return defaultSerializeQueryArgs(args);
  return `${identity}:${context}:${defaultSerializeQueryArgs(args)}`;
}

export function staleTenantError() {
  return new DOMException('Tenant context changed', 'AbortError');
}
